import { Breadcrumb } from "@refinedev/mui";
import { Box } from "@mui/material";
import PageHeading from "../../components/pageHeading";
export const ActivityBasedClassesConductedInCYRC = () => {
  return (
    <Box>
      <Breadcrumb />
      <PageHeading heading="Activity-based classes conducted in CYRC" />
    </Box>
  );
};
